import React from 'react';
import JobSingleHero from './JobSingleHero';
import JobSocialShares from './JobSocialShares';
import JobSingleContent from './JobSingleContent';
import JobSingleBox from './JobSingleBox';
import JobRelatedPositions from './JobRelatedPositions';
import axios from 'axios'

class JobSingle extends React.Component {

  render() {
    const SingleJobselectionData = window.singlejob_desc_setting && Array.isArray(window.singlejob_desc_setting) ? window.singlejob_desc_setting : [];
    return (
      <section>
        {/* hero */}
        <JobSingleHero key={this.props.jobs._id} job_data={this.props.jobs} />

          <section className="section section--job-info">
            <div className="container">
              <div className="article-body row">

                {/* social shares */}
                <JobSocialShares key={this.props.jobs._id} job_data={this.props.jobs} social_data={this.props.socialshares} />

                {/* content */}
                <JobSingleContent key={this.props.jobs._id} job_data={this.props.jobs} />

                {/* box */}
                <JobSingleBox key={this.props.jobs._id} job_data={this.props.jobs} SingleJobselectionData={SingleJobselectionData} />

              </div>
            </div>
          </section>

      </section>
    )
  }
}

export default JobSingle;
